(function () {
  function clamp(value, min, max) {
    if (Number.isNaN(value)) return min;
    if (value < min) return min;
    if (max != null && value > max) return max;
    return value;
  }

  function bindQtyButtons(root) {
    root.querySelectorAll('.launch-quick-add__product-form').forEach(function (form) {
      if (form.dataset.launchBound === 'true') return;
      form.dataset.launchBound = 'true';

      var input = form.querySelector('.launch-quick-add__qty-input');
      if (!input) return;
      var min = parseInt(input.min, 10) || 1;
      var maxAttr = input.getAttribute('max');
      var max = maxAttr ? parseInt(maxAttr, 10) : null;

      form.querySelectorAll('[data-qty-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(input.value, 10) || min;
          var next = btn.dataset.qtyAction === 'increment' ? current + 1 : current - 1;
          input.value = clamp(next, min, max);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      input.addEventListener('change', function () {
        input.value = clamp(parseInt(input.value, 10), min, max);
      });
    });
  }

  function flashSuccess(button) {
    if (!button) return;
    button.classList.add('is-success');
    window.setTimeout(function () {
      button.classList.remove('is-success');
    }, 1800);
  }

  function onCartUpdate(event) {
    var detail = event && event.detail;
    if (!detail || detail.source !== 'product-form') return;
    var variantId = detail.productVariantId;
    if (!variantId) return;
    document
      .querySelectorAll('.launch-quick-add__product-form input.product-variant-id[value="' + variantId + '"]')
      .forEach(function (variantInput) {
        var form = variantInput.closest('.launch-quick-add__product-form');
        if (!form) return;
        var qty = form.querySelector('.launch-quick-add__qty-input');
        if (qty) qty.value = qty.min || 1;
        flashSuccess(form.querySelector('.launch-quick-add__submit'));
      });
  }

  function init() {
    bindQtyButtons(document);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        onCartUpdate({ detail: data });
      });
    }
    var observer = new MutationObserver(function () {
      bindQtyButtons(document);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
